<ng-container [ngSwitch]="mode">
  <ng-container
    *ngSwitchCase="LabelMode.DEFAULT"
    [ngTemplateOutlet]="default"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.INLINE"
    [ngTemplateOutlet]="inline"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.NO_LABEL"
    [ngTemplateOutlet]="input"
  ></ng-container>
</ng-container>

<ng-template #input>
  <div class="demo-inline-spacing" [ngClass]="classes">
    <div
      class="form-check form-check-inline form-check-custom form-check-sm"
      [ngClass]="InputClass"
    >
      <input
        type="checkbox"
        [id]="name"
        [name]="name"
        class="form-check-input"
        [formControl]="form"
        (change)="onInputChange($event)"
      />
      <!-- (change)="onInputChange($event.target?.checked!)" -->
      <label
        class="custom-control-label col-form-label fs-6 py-2"
        [for]="name"
        >{{ inputLabel | translate }}</label
      >
    </div>
  </div>
</ng-template>

<ng-template #default>
  <div class="form-group">
    <label
      [for]="name"
      class="col-form-label  fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline">
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <label
      [for]="name"
      class="col-form-label fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
  </div>
</ng-template>
